import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const scrollReveal = () => {
  const content = document.querySelectorAll('.scroll-reveal');

  gsap.defaults({ ease: 'expo', duration: 1.25 });
  gsap.set(content, { y: 100 });

  ScrollTrigger.batch(content, {
    onEnter: (batch) => gsap.to(batch, {
      opacity: 1,
      y: 0,
      stagger: {
        each: 0.15,
      },
      overwrite: true
    }),
    onLeave: (batch) => gsap.set(batch, {
      opacity: 0,
      y: -100,
      overwrite: true
    }),
    onEnterBack: (batch) => gsap.to(batch, {
      opacity: 1,
      y: 0,
      //      stagger: 0.15,
      overwrite: true
    }),
    onLeaveBack: (batch) => gsap.set(batch, {
      opacity: 0,
      y: 100,
      overwrite: true
    })
  });

  ScrollTrigger.addEventListener('refreshInit', () => gsap.set(content, { y: 0 }));
};

export default scrollReveal;
